// refreshHandler.js
import axios from "axios";
import { BASE_URL } from "./apiConfig";
import { getRefreshToken } from "./helper";
import Cookies from "js-cookie";

let isRefreshing = false;
let failedQueue = [];

export const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

export const handle401Error = async (error, apiInstance) => {
  const originalRequest = error.config;

  if (error.response?.status === 401 && !originalRequest._retry) {
    if (isRefreshing) {
      // Wait for refresh to finish
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers["Authorization"] = `Bearer ${token}`;
          return apiInstance(originalRequest);
        })
        .catch((err) => Promise.reject(err));
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const refreshToken = getRefreshToken();
      const response = await axios.post(
        `${BASE_URL}refresh-token`,
        {},
        {
          headers: { Authorization: `Bearer ${refreshToken}` },
        },
      );

      const newToken = response.data.data.token;
      const newRefreshToken = response.data.data.refresh_token;

      if (newToken) {
        const localData =
          JSON.parse(localStorage.getItem("pos-user-data")) || {};
        localData.token = newToken;
        localData.refresh_token = newRefreshToken;
        localStorage.setItem("pos-user-data", JSON.stringify(localData));
        Cookies.set("pos-user-data", newToken, {
          domain: window.location.hostname,
          path: "/",
          expires: 7,
          secure: true,
          sameSite: "Lax",
        });
        window.dispatchEvent(new Event("token-changed"));
      }

      apiInstance.defaults.headers.common["Authorization"] =
        `Bearer ${newToken}`;
      processQueue(null, newToken);

      // Retry original request
      return apiInstance(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError, null);
      localStorage.clear();
      sessionStorage.clear();
      Cookies.remove("pos-user-data", {
        domain: window.location.hostname,
        path: "/",
      });
      window.location.href = "/authentication/login";
      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }

  return Promise.reject(error);
};
